if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.codeButtons = this.querySelectorAll('.js-copy-code');
      this.status = this.querySelector('.js-copy-status');
      this.onCopyClick = this.onCopyClick.bind(this);
      this.codeButtons.forEach((btn) => btn.addEventListener('click', this.onCopyClick));

      this.initBrandDrawer();

      // Centra el logo resaltado si la fila de logos se desplaza (móvil).
      const active = this.querySelector('.announcement__brand-link.is-active');
      const brands = this.querySelector('.announcement__brands');
      if (active && brands && brands.scrollWidth > brands.clientWidth) {
        brands.scrollLeft = active.offsetLeft - (brands.clientWidth - active.offsetWidth) / 2;
      }
    }

    disconnectedCallback() {
      if (this.codeButtons) {
        this.codeButtons.forEach((btn) => btn.removeEventListener('click', this.onCopyClick));
      }
      if (this.drawer) {
        this.closeDrawer(true);
        document.removeEventListener('keydown', this.onKeydown);
        // Devuelve el panel a la sección: si se vuelve a conectar, se reubica; si se elimina, se va con ella.
        this.appendChild(this.drawer);
      }
    }

    /**
     * Panel de marcas (móvil). Se mueve al <body> para que quede por encima del header.
     */
    initBrandDrawer() {
      this.openBtn = this.querySelector('.js-brand-drawer-open');
      const drawer = this.querySelector('.brand-drawer');
      if (!this.openBtn || !drawer) return;

      // Elimina un panel previo de esta misma sección (recarga en el editor de temas).
      const stale = document.body.querySelector(`:scope > #${drawer.id}`);
      if (stale && stale !== drawer) stale.remove();

      this.drawer = drawer;
      document.body.appendChild(drawer);

      this.onKeydown = this.onKeydown.bind(this);
      this.openBtn.addEventListener('click', () => this.openDrawer());
      drawer.querySelectorAll('.js-brand-drawer-close').forEach((el) => {
        el.addEventListener('click', () => this.closeDrawer());
      });
      document.addEventListener('keydown', this.onKeydown);
    }

    openDrawer() {
      const { drawer } = this;
      clearTimeout(this.drawerTimer);
      drawer.hidden = false;
      // Forzar reflow para que la transición se ejecute.
      drawer.getBoundingClientRect();
      drawer.classList.add('is-open');
      document.documentElement.classList.add('brand-drawer-open');
      this.openBtn.setAttribute('aria-expanded', 'true');
      const first = drawer.querySelector('.brand-drawer__close');
      if (first) first.focus({ preventScroll: true });
    }

    closeDrawer(instant = false) {
      const { drawer } = this;
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('brand-drawer-open');
      this.openBtn.setAttribute('aria-expanded', 'false');
      if (instant) {
        drawer.hidden = true;
        return;
      }
      this.drawerTimer = setTimeout(() => { drawer.hidden = true; }, 300);
      this.openBtn.focus({ preventScroll: true });
    }

    onKeydown(evt) {
      if (!this.drawer || this.drawer.hidden) return;

      if (evt.key === 'Escape') {
        this.closeDrawer();
        return;
      }

      // Mantiene el foco dentro del panel.
      if (evt.key === 'Tab') {
        const focusable = this.drawer.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (evt.shiftKey && document.activeElement === first) {
          evt.preventDefault();
          last.focus();
        } else if (!evt.shiftKey && document.activeElement === last) {
          evt.preventDefault();
          first.focus();
        }
      }
    }

    /**
     * Copia el código al portapapeles (con alternativa para navegadores antiguos).
     * @param {string} text - Texto a copiar.
     * @returns {Promise}
     */
    static copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          if (document.execCommand('copy')) resolve();
          else reject();
        } catch (err) {
          reject(err);
        } finally {
          textarea.remove();
        }
      });
    }

    onCopyClick(evt) {
      const btn = evt.currentTarget;
      const code = btn.dataset.code;
      const label = btn.querySelector('.announcement__code-text');
      const copiedLabel = btn.dataset.copiedLabel || '✓';

      AnnouncementBar.copyText(code).then(
        () => {
          clearTimeout(btn.copyTimer);
          btn.style.minWidth = `${btn.offsetWidth}px`;
          label.textContent = copiedLabel;
          btn.classList.add('is-copied');
          if (this.status) this.status.textContent = `${code}: ${copiedLabel}`;

          btn.copyTimer = setTimeout(() => {
            label.textContent = code;
            btn.classList.remove('is-copied');
            btn.style.minWidth = '';
            if (this.status) this.status.textContent = '';
          }, 1800);
        },
        () => {
          if (window.theme && theme.strings && theme.strings.discountCopyFail) {
            alert(theme.strings.discountCopyFail); // eslint-disable-line
          }
        }
      );
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
